// AnimationsLayer.jsx - Visual effects and animation system
import React, { useEffect } from 'react';
import { destroyEffectsCanvas } from '@components/game/effects/EffectsCanvas';

// Simple container getter using CSS selector - more reliable than refs
export const getAnimationContainer = () => {
  const container = document.querySelector('.visual-effects-layer');
  if (!container) {
    console.warn('[AnimationsLayer] Container not found in DOM - looking for .visual-effects-layer');
  }
  return container;
};

/**
 * Visual Effects Layer - Provides DOM container for animations
 * Uses CSS class selector for reliable container access
 */
const AnimationsLayer = () => {
  useEffect(() => {
    // Clean up when component unmounts
    return () => {
      destroyEffectsCanvas();
    };
  }, []);
  
  // Just render the container div with a reliable CSS class
  return (
    <div 
      className="visual-effects-layer" 
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 100
      }}
    />
  );
};

export default AnimationsLayer;